<span class="modal-close-icon"><i class="fa-regular fa-circle-xmark" (click)="closeModal('dismiss')"></i></span>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <form [formGroup]="bookedLessonDateTimeGroup">
        <div class="mt-5">
          <div class="form-row">
            <div class="col-md-4 mb-3">
              <label for="bookingDate">Start Date <sup>*</sup></label>
              <input type="date" class="form-control" formControlName="bookingDate" id="bookingDate"
                     placeholder="Start Date">
            </div>
            <div class="col-md-4 mb-3">
              <label for="startTime">Start Time <sup>*</sup></label>
              <input type="time" class="form-control" formControlName="startTime" id="startTime"
                     placeholder="Start Time">
            </div>
            <div class="col-md-4 mb-3">
              <label for="endTime">End Time <sup>*</sup></label>
              <input type="time" class="form-control" formControlName="endTime" id="endTime"
                     placeholder="End Time">
            </div>
          </div>
          <div class="modal-buttons text-center">
            <button
              type="button"
              class="btn btn-default add-edit-button"
              (click)="closeModal(bookedLessonDateTimeGroup)"
              [disabled]="!validate() || loading"
            >
              Save
            </button>
            <button type="button" class="btn btn-light cancel-button" (click)="closeModal({value: 'cancel'})">Cancel</button>
          </div>
          <div class="form-row mt-4">
            <div class="alert alert-danger" *ngIf="errorMessage">Error: {{ errorMessage }}</div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
